<template>
  <div class="container">
    <headerNavbar title="体检报告" />
    <div class="user-profile-wrapper">
      <div class="header-title">点击头像查看体检报告</div>
      <div class="user-list-wrap">
        <div v-for="user in userList" class="user-item" :class="user==userProfile?'user-item--active':''"
          @click="setActiveUser(user)">
          <div class="avatar-wrapper">
            <img :src="getAvatar(user.sex)" />
          </div>
          <div>{{user.name}}</div>
        </div>
        <div class="user-item">
          <div class="avatar-wrapper">
            <div class="btn-wrap">
              <router-link to="/user/addprofile">
                <van-icon name="add" size="36" color="#a5b4c3" />
              </router-link>
            </div>
          </div>
          <div>新增亲属</div>
        </div>
      </div>
    </div>

    <div v-if="reportCount>0" class="tabs-wrap">
      <van-tabs v-model="activeReportType">
        <van-tab title="处理中">
          <div class="report-list-wrapper">
            <div v-if="processingReports && processingReports.length>0">
              <div class="group-title">待发布的体检报告</div>
              <div class="report-item" v-for="(rep,index) in processingReports" :key="index">
                <van-steps :active="rep.step" active-color="var(--color-main)">
                  <van-step>到院体检</van-step>
                  <van-step>项目汇总</van-step>
                  <van-step>主检审核</van-step>
                  <van-step>报告发布</van-step>
                </van-steps>
                <div class="report-progress">
                  <van-cell title="体检日期" :value="rep.tjrq|dateFormat" />
                  <van-cell title="体检编号" :value="rep.tjbh" />
                  <van-cell title="报告进度" is-link value="查看" @click="showReportItems(rep)" />
                </div>
              </div>
            </div>
            <div class="report-empty-wrapper" v-else>
              <img src="@/assets/images/empty_document.jpg" style="width:240px;margin-top:60px;" />
              <div class="report-empty-note">没有处理中的报告</div>
            </div>
          </div>
        </van-tab>
        <van-tab title="已完成">
          <div class="report-list-wrapper">
            <div v-if="completedReports && completedReports.length>0">
              <div class="group-title">已完成的体检报告</div>
              <div class="report-item" v-if="reports.length>1"
                @click="$router.push({path:'/report/compareList',query:{profileId:userProfile.id}})">
                <div class="report-content">
                  <div class="report-icon" style="width:60px;text-align:center;">
                    <img src="../../assets/images/icon-report-trend.png" style="width:48px;height:48px;" />
                  </div>
                  <div class="report-info">
                    <div class="patient-name" style="margin-top:6px;line-height:36px;">体检报告对比</div>
                    <div>
                      历年体检结果详细对比
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-item" v-for="(rep,index) in completedReports">
                <div class="report-content">
                  <div class="report-icon">
                    <img src="../../assets/images/icon-report.png" />
                  </div>
                  <div class="report-info">
                    <div class="patient-name">{{rep.name}}</div>
                    <div>
                      体检日期
                      <span class="exam-date">{{rep.tjrq|dateFormat()}}</span>
                    </div>
                    <div>
                      体检编号
                      <span class="exam-date">{{rep.tjbh}}</span>
                    </div>
                  </div>
                </div>
                <div class="report-footer">
                  <div class="rating-status">
                    <span v-if="rep.is_rated">评价完成</span>
                  </div>
                  <span class="report-buttons">
                    <span @click="handleShowReport(rep,false)">
                      <van-button round plain type="default" size="small">查看报告</van-button>
                    </span>
                    <span @click="handleShowReport(rep,true)" v-if="report_enable_pdf && rep.pdfEnable"
                      style="margin-left:16px">
                      <van-button round plain type="default" size="small">下载报告</van-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="report-empty-wrapper" v-else>
              <img src="@/assets/images/empty_document.jpg" style="width:240px;margin-top:60px;" />
              <div class="report-empty-note">没有已完成的报告</div>
            </div>
          </div>
        </van-tab>
        <van-tab title="其它报告">
          <div class="report-list-wrapper">
            <div class="group-title">其它类型的报告</div>
            <div v-if="externalReports && externalReports.length>0">
              <div class="report-item" v-for="(rep,index) in externalReports">
                <div class="report-content">
                  <div class="report-icon">
                    <img src="../../assets/images/icon-report.png" />
                  </div>
                  <div class="report-info">
                    <div class="patient-name">{{rep.inspection_item_name}}</div>
                    <div>
                      报告日期
                      <span class="exam-date">{{rep.report_date}}</span>
                    </div>
                    <div>
                      体检编号
                      <span class="exam-date">{{rep.tjbh}}</span>
                    </div>
                  </div>
                </div>
                <div class="report-footer">
                  <span class="report-buttons">
                    <span @click="showExtReport(rep)">
                      <van-button round plain type="default" size="small">查看报告</van-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="report-empty-wrapper" v-else>
              <img src="@/assets/images/empty_document.jpg" style="width:240px;margin-top:60px;" />
              <div class="report-empty-note">未查询到其它类型的报告</div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <div class="report-empty-wrapper" v-else>
      <img src="@/assets/images/empty_document.jpg" style="width:240px;margin-top:60px;" />
      <div class="report-empty-note">未查询到体检报告</div>
      <div class="report-empty-note">请确认手机号及证件号码是否正确</div>
      <div class="report-empty-note">如有疑问，请致电机构介绍页面的电话</div>
    </div>

    <van-popup position="bottom" v-model="showPopup" round :style="{ height: '70%' }" class="popup-wrapper">
      <div v-if="report">
        <h3 class="popup-title">体检项目完成进度</h3>
        <ul>
          <li v-for="(item,i) in report.items" class="report-item-row">
            <div class="report-item-name">{{i+1}}. {{item.xmmc}}</div>
            <div class="report-item-status">{{item.jcztmc}}</div>
          </li>
        </ul>
      </div>
    </van-popup>

    <rating-dialog :userProfile="userProfile" :examNo="examNo" :visible="showRatingDialog"
      @change="handleRatingChanged" />
  </div>
</template>
<style lang="less" scoped>
  /deep/ .van-step--finish .van-step__circle {
    background-color: var(--color-main);
  }

  .container {
    min-height: 100vh;
  }

  .user-profile-wrapper {
    background-color: #fff;
    padding: 8px 0;

    .header-title {
      font-size: 14px;
      padding: 8px 12px;
    }

    .user-list-wrap {
      display: flex;
      overflow-x: auto;

      .user-item {
        width: 80px;
        height: 80px;
        text-align: center;
        flex-shrink: 0;
        font-size: 12px;
        font-weight: 400;

        .avatar-wrapper {
          margin: auto 0;
          text-align: center;

          img {
            width: 40px;
            height: 40px;
            margin: 8px 12px 0 12px;
            border-radius: 50%;
            border: 2px solid transparent;
          }
        }

        .btn-wrap {
          text-align: center;
          margin: auto 0;

          i {
            margin: 8px 12px 7px 12px;
            border-radius: 50%;
            border: 2px solid transparent;
          }
        }
      }

      .user-item--active {
        color: var(--color-main);

        img {
          border: 2px solid var(--color-main);
        }

      }
    }
  }

  .tabs-wrap {
    margin-top: 16px;
    background: #fff;
    min-height: calc(100vh - 200px);
  }

  .report-list-wrapper {
    padding: 0 16px;

    .group-title {
      margin-top: 16px;
      margin-bottom: 16px;
      display: block;
      position: relative;
    }

    .group-title:after {
      content: "";
      display: inline-block;
      width: 4px;
      height: 16px;
      background: var(--color-main);
      border-radius: 2px;
      position: absolute;
      left: -16px;
      top: 4px;
    }

    .report-item {
      border-radius: 5px;
      background-color: #fff;
      box-shadow: 0px 0px 10px 1px rgb(228, 228, 228);
      padding: 8px;
      margin-bottom: 24px;

      .report-content {
        display: flex;

        .report-info {
          flex: 1;
        }

        .report-icon {
          padding: 16px;

          img {
            height: 60px;
            width: 60px;
          }
        }

        .report-info {
          margin-left: 8px;
          padding-bottom: 8px;
          font-size: 13px;
          color: #808080;

          .patient-name {
            font-size: 16px;
            font-weight: 500;
            line-height: 32px;
            color: #2c3e50;
          }

          div {
            color: #808080;
            line-height: 24px;

            span {
              margin-left: 12px;
              color: #2c3e50;
            }
          }
        }
      }

      .report-footer {
        border-top: 1px dashed #ebedf0;
        padding: 8px 8px 0;
        font-size: 13px;
        display: flex;

        .rating-status {
          text-align: left;
          color: #808080;
          line-height: 26px;
        }

        .report-buttons {
          flex: 1;
          text-align: right;
        }

        .report-footer--button {}
      }

      .report-progress {
        .van-cell {
          padding: 10px 8px;
        }
      }
    }
  }

  .report-empty-wrapper {
    height: calc(100vh - 180px);
    background: #fff;
    text-align: center;

    .report-empty-note {
      line-height: 32px;
      color: #808080;
    }
  }

  .popup-wrapper {
    .popup-title {
      font-size: 18px;
      font-weight: 400;
      line-height: 48px;
      margin: 0 16px;
    }

    .report-item-row {
      margin: 0 16px;
      display: flex;
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);

      .report-item-name {
        flex: 1;
      }

      .report-item-status {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.45)
      }
    }

  }
</style>

<script>
  import Vue from "vue";
  import {
    Step,
    Steps,
    Toast
  } from "vant";
  import headerNavbar from '../components/headerNavbar';
  Vue.use(Step);
  Vue.use(Steps);
  import * as api_user from "@/api/user";
  import * as auth from "@/libs/auth";
  import * as api_report from "@/api/report";
  import {
    getConfigs
  } from '@/api/hospital';
  import RatingDialog from '../components/ratingDialog.vue';
  import moment from 'moment';
  export default {
    components: {
      headerNavbar,
      RatingDialog
    },
    data() {
      return {
        userList: [],
        userProfile: null,
        reports: null,
        report: null,
        processingReports: [],
        completedReports: [],
        showPopup: false,
        report_enable_pdf: false,
        rating_before_report: false, //是否在查看报告前弹出评价窗口
        showRatingDialog: false,
        examNo: "",
        activeReportType: 1,
        externalReports: null, //外送或其它类型的报告
      };
    },
    computed: {
      reportCount() {
        var i = 0;
        if (this.reports && this.reports.length > 0) {
          i += this.reports.length;
        }
        if (this.externalReports && this.externalReports.length > 0) {
          i += this.externalReports.length
        }
        return i;
      }
    },
    async mounted() {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '正在查询',
      });

      //获取界面配置 
      getConfigs(this.$route.query.hospid).then(res => {
        let configs = res.data;
        let config = configs.find(it => {
          return it.code === 'report_enable_pdf'
        });
        if (config && config.value === '是') {
          this.report_enable_pdf = true;
        } else {
          this.report_enable_pdf = false;
        }

        let config_rating_before_report = configs.find(it => {
          return it.code === 'rating_before_report'
        });
        this.rating_before_report = config_rating_before_report && config_rating_before_report.value == "是";
      })
      let userInfo = api_user.getLoginedUser();
      if (userInfo) {
        api_user.getUserProfiles().then(
          res => {
            if (res.code == "200" && res.data) {
              this.userList = res.data;
              if (this.userList && this.userList.length > 0) {
                this.setActiveUser(this.userList[0])
              }
              //this.userProfile = res.data[0];
              //idcard = "310225199307015437"; //测试
              //return api_report.getReports(this.userProfile.id);

            }
          }
        ).catch(err => {
          console.log(err);
          this.$toast.clear();
          this.$Toast("查询体检报告出错")
        });
      }
    },
    //
    methods: {
      getUserReports(id) {
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '正在查询',
        });
        api_report.getReports(id).then(result => {
          this.reports = result.data;
          this.processingReports = this.reports.filter(r => {
            return r.zjzt == 0 || r.qcResult == '0';
          });
          this.completedReports = this.reports.filter(r => {
            return r.zjzt > 0 && r.qcResult != '0';
          });

          this.processingReports.forEach(r => {
            r.step = 0;
            if (r.zjzt > 0) {
              if (r.qcResult != '0') {
                r.step = 3;
              } else {
                r.step = 2;
              }
            } else {
              if (r.tjzt == 0) {
                r.step = 0;
              } else if (r.tjzt == 1) {
                r.step = 0
              } else if (r.tjzt == 2) {
                r.step = 1;
              } else {
                r.step = 2;
              }
            }
          });

          this.$toast.clear();
        })
      },
      showReportItems(rep) {
        this.report = rep;
        this.showPopup = true;
        console.log(rep.items);
      },
      showReportDetail(id) {
        this.$router.push({
          path: "/report",
          query: {
            repid: id
          }
        });
      },

      handleShowReport(rep, showPdf) {
        this.report = rep
        var daysDiff = moment().diff(moment(rep.tjrq), 'days');
        if (this.rating_before_report && !rep.is_rated && daysDiff < 180) {
          this.$Dialog.alert({
            title: '满意度评价',
            message: '尊敬的客户，为了进一步提高我们的服务质量，敬请认真评价您本次的体检服务，谢谢配合！',
            confirmButtonText: '去评价'
          }).then(() => {
            this.examNo = rep.tjbh;
            this.showRatingDialog = true;
          });
        } else {
          if (showPdf) {
            this.$router.push({
              path: '/pdfreport',
              query: {
                reportKey: rep.reportKey
              }
            })
          } else {
            this.$router.push({
              path: '/report',
              query: {
                repid: rep.tjbh
              }
            })
          }

        }
      },
      handleRatingChanged() {
        this.showRatingDialog = false;
        if (this.userProfile) {
          this.getUserReports(this.userProfile.id);
        }
      },
      getAvatar(sex) {
        switch (sex) {
          case 1:
            return require("../../assets/images/avatar-male.png");
            break;
          case 2:
            return require("../../assets/images/avatar-female.png");
            break;
          default:
            return require("../../assets/images/avatar-male.png");
            break;
        }
      },
      getExternalReports() {
        api_report.getExtReports(this.userProfile.id).then(res => {
          this.externalReports = res.data;
          console.log(this.externalReports);
        })

      },
      showExtReport(rep) {
        if ((rep.report_data_type == 'link' || rep.report_data_type == 'pdf') && rep.report_url !== '') {
          window.location.href = rep.report_url;
        }
      },
      setActiveUser(user) {
        this.userProfile = user;
        this.getUserReports(user.id);
        this.getExternalReports();
      },
    }
  }
</script>